import { Box, Typography, Button, CircularProgress } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';

const ConnectStep = ({ loading, onConnect }) => (
  <Box sx={{ textAlign: 'center', py: 4 }}>
    <CloudUpload sx={{ fontSize: 80, color: 'primary.main', mb: 2 }} />
    <Typography variant="h6" gutterBottom>
      Conectar con OneDrive
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
      Autoriza el acceso a tu cuenta de OneDrive para importar documentos
    </Typography>
    <Button
      variant="contained"
      size="large"
      onClick={onConnect}
      disabled={loading}
      startIcon={loading ? <CircularProgress size={20} /> : <CloudUpload />}
    >
      {loading ? 'Conectando...' : 'Conectar con OneDrive'}
    </Button>
  </Box>
);

export default ConnectStep;
